var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5274_17193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6436 45.7896H104.464V47.2807H87.3688V58.5033H103.445V59.9944H87.3688V72.3157H104.66V73.8068H85.6436V45.7896ZM106.15 45.7896H108.15L117.011 58.1109L126.069 45.7896L138.389 30.1387L118.149 59.4058L128.578 73.8068H126.5L117.011 60.7007L107.483 73.8068H105.445L115.953 59.4058L106.15 45.7896ZM129.323 47.2807V45.7896H150.771V47.2807H140.89V73.8068H139.165V47.2807H129.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0981 45.7896H64.2547L93.9922 90.1465L81.7031 73.8068L63.9018 47.9085L63.8234 73.8068H62.0981V45.7896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.597 71.8658C150.954 71.8658 151.214 71.5936 151.214 71.2418C151.214 70.89 150.954 70.6178 150.597 70.6178C150.245 70.6178 149.98 70.89 149.98 71.2418C149.98 71.5936 150.245 71.8658 150.597 71.8658ZM152.293 70.2241C152.293 71.2627 153.044 71.9412 154.139 71.9412C155.305 71.9412 156.01 71.2418 156.01 70.0272V65.7511H155.07V70.023C155.07 70.6973 154.731 71.0575 154.13 71.0575C153.593 71.0575 153.228 70.7225 153.216 70.2241H152.293ZM157.24 70.1696C157.307 71.2502 158.209 71.9412 159.552 71.9412C160.987 71.9412 161.885 71.2167 161.885 70.0607C161.885 69.1519 161.373 68.6493 160.131 68.3603L159.464 68.197C158.675 68.0127 158.356 67.7656 158.356 67.3342C158.356 66.7898 158.851 66.4338 159.594 66.4338C160.299 66.4338 160.786 66.7814 160.874 67.3384H161.788C161.734 66.3207 160.836 65.6045 159.606 65.6045C158.285 65.6045 157.403 66.3207 157.403 67.397C157.403 68.2849 157.903 68.8127 158.998 69.0681L159.779 69.2566C160.58 69.4451 160.932 69.7215 160.932 70.1822C160.932 70.7183 160.379 71.1078 159.623 71.1078C158.813 71.1078 158.251 70.7434 158.171 70.1696H157.24Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5274_17193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    fill: "white",
    transform: "translate(62 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.54009f5a915dabac84eaa5dcc22abea9.svg";
export { ForwardRef as ReactComponent };